import { ListItemCardProps } from "@components/ListItemCardCst/types";

export const mapUserToCard = (user: any): ListItemCardProps => {
  const fullName = [user.name, user.surname].filter(Boolean).join(" ").trim();
  const title = fullName || user.email || user.external_id || "-";

  return {
    title,
    subtitle: {
      id: user.id_user,
      activityType: user.email || user.external_id || undefined,
    },
    badges: [],
    actions: [],
  };
};
